import * as React from "react";

import { ContextualActionNames } from "../../../../../Common/FormActionHandlers/ContextualActionNames";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

export type ContextualActionSet = { [actionName in ContextualActionNames]?: ContextualActionHandler };

const ContextualActionsContext = React.createContext<ContextualActionSet>({});

export interface ContextualActionHandlerParams {
    bindingPath?: AbsoluteModelPath;
}

export type ContextualActionHandler = (params: ContextualActionHandlerParams) => void | Promise<void>;

export function useContextualActions(): ContextualActionSet {
    return React.useContext(ContextualActionsContext);
}

interface ContextualActionsProviderProps {
    actions: ContextualActionSet;
    children: React.ReactNode;
}

export function ContextualActionsProvider(props: ContextualActionsProviderProps) {
    const prevContext = useContextualActions();
    const mergedValue = React.useMemo(() => ({ ...prevContext, ...props.actions }), [prevContext, props.actions]);
    return <ContextualActionsContext.Provider value={mergedValue}>{props.children}</ContextualActionsContext.Provider>;
}
